import React from 'react';
import NavUser from '../components/navUser'
import Selector from '../components/selector'

export default function VideoScreen({history}) {
    return (
        <div className="p-0 m-0">
            <NavUser history={history}/>
            <div className='content'>
            <div className='container'>
            <h5 className='text-light  mt-2 video-text'>Potenciação</h5>
            <h6 className='text-light video-text'>Aula 5</h6>
            </div>
            <div className='video-area'>

                <div className='videoDiv embed-responsive embed-responsive-16by9'>
                    <iframe 
                        className='iframe'
                        src="https://player.vimeo.com/video/402073155?app_id=122963" 
                        frameborder="0"
                        allow="autoplay; fullscreen" 
                        allowfullscreen="" 
                        title="Gotogoal"
                    />
                </div>
                <div className='selecDiv'>
                    <Selector/>
                </div>
                
               
            </div>
            
        </div>

        </div>
    );
}
